"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMAGE_PLACEHOLDER = void 0;
const IMAGE_PLACEHOLDER = exports.IMAGE_PLACEHOLDER = 'pid-image-placeholder';